// tslint:disable: max-line-length

import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { Shell } from '@app/shell/shell.service';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: 'profile',
      data: { title: 'My Profile' },
      loadChildren: () =>
        import('./profile/profile.module').then((m) => m.ProfileModule),
    },
  ]),
  Shell.childRoutes([
    {
      path: 'bookings',
      data: { title: 'Bookings' },
      loadChildren: () =>
        import('./booking/booking.module').then((m) => m.BookingModule),
    },
  ]),

  Shell.childRoutes([
    {
      path: 'faqs',
      data: { title: 'Knowledge Base' },
      loadChildren: () =>
        import('./faqs/faqs.module').then((m) => m.FaqsModule),
    },
  ]),

  Shell.childRoutes([
    {
      path: 'help-center',
      data: { title: 'Help Center' },
      loadChildren: () =>
        import('./help-center/help-center.module').then(
          (m) => m.HelpCenterModule,
        ),
    },
  ]),

  {
    path: 'lc',
    loadChildren: () =>
      import('./sms-link/sms-link.module').then((m) => m.SmsLinkModule),
  },
  {
    path: 'agency',
    loadChildren: () =>
      import('./tracking-link/tracking-link.module').then(
        (m) => m.TrackingLinkModule,
      ),
  },
  {
    path: 'saudia-bookings',
    loadChildren: () =>
      import('./airline-booking/airline-booking.module').then(
        (m) => m.AirlineBookingModule,
      ),
  },

  // Fallback when no prior route is matched
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
  providers: [],
  declarations: [],
})
export class AppRoutingModule {}
